
<template>
	<div class="page-container">

		<md-toolbar class="top-menu-bar md-primary" style='background:#251106;'>
			  <md-button class="md-icon-button" @click="$router.go(-1)">
		        <md-icon>arrow_back</md-icon>
		      </md-button>
		      <span class="md-title">비밀번호 변경</span>
		</md-toolbar>
		<md-content>
			<div class="from-box">
				<form  id="updateForm" action="memberProcApp/changePassword" novalidate @submit="formSubmit">
					<div class='form-group'>   
						<md-field :md-toggle-password="false">
						  <label>현재 비밀번호</label>
						  <md-input :required="true" name="nowpass" id="nowpass" type="password"></md-input>
						</md-field>
						<div class="md-error-box">현재 비밀번호를 입력하세요</div>
					</div>
					<div class='form-group'>   
						<md-field :md-toggle-password="false">
						  <label>새비밀번호</label>
						  <md-input :required="true" :option="'userpw'" type="password" name="upass" id="upass"></md-input>
						</md-field>
						<div class="md-warning-box">8~15자의 영문자와 숫자 특수문자의 조합</div>
						<div class="md-error-box">비밀번호를 입력하세요</div>
					</div>
					<div class='form-group'>   
						<md-field :md-toggle-password="false">
						  <label>새비밀번호 확인</label>
						  <md-input :required="true"  :match="'#upass'" type="password" name="repass" id="repass"></md-input>
						</md-field>
						<div class="md-warning-box fail-warning-hide">비밀번호와 비밀번호확인이 일치하지 않습니다</div>
						<div class="md-error-box">비밀번호 확인을 입력하세요</div>
					</div>
					<p style="margin-top:40px;">
						<md-button class="md-raised md-accent" style='width:48.5%;margin:0 1.5% 0 0;background:#999999;min-height:40px;' type="button" @click="$router.go(-1)">취소</md-button>
						<md-button class="md-raised md-accent" style='width:48.5%;margin:0 0 0 1.5%;background:#251106;min-height:40px;' type="submit">확인</md-button>
					</p>
				</form>
			</div>
		</md-content>
		
	</div>	

</template>

<script>


export default {
  name: 'MembercCangePassword',
  data () {
	
	return {
  	   
    }
  },
  created: function() {
	  if(!localStorage.getItem('memberkey')) {
		  this.$router.push({path:'/'});
		  return;
	  }
	  
  },
  methods: {
	  formSubmit(e) {
		var $f = $('#updateForm');
		var obj = this;
		this.$form.validate($f,e,function(resp) {
			obj.updateInfo(resp);
			
		});
		
	  },
	  updateInfo(resp) {

		  var result = resp.result;
		  var params = {};
		  switch(result) {
			  case 'succ':
				localStorage.setItem('memberkey',resp.memberkey);
				params.content = '비밀번호가  변경되었습니다';	
				params.doAction = function() {
					this.$router.go(-1);	
				}
		 
			  break;
			  case 'wrongpass':
				params.content = '잘못된 현재 비밀번호 입니다';	
			  break;
			  default:
				params.content = '시스템 에러';	
			  break;
			  
		  }
		  this.$eventBus.$emit('dialogOpen',params);
		  
	  }

  },
  mounted: function() {
	$('.page-container').css('min-height',$(window).height());
  }

}
</script>

<style lang="scss" scoped>

@import "~vue-material/dist/theme/engine"; // Import the theme engine
@include md-register-theme("default", (
  primary: #000000,
 
));
@import "~vue-material/dist/theme/all"; // Apply the theme
.md-field {
    &.md-focused,
    &.md-highlight {
      &:after {
	    z-index:10;
		border:solid 1px #000;
		height:1px;
		
	  }
   
	}
	.md-input {
	    z-index:10;
		border-bottom:solid 1px #888;
		
	}
}

.md-content {margin:0}
.page-container {width:100%;min-height:100%;background:#fff;}

</style>